import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { nanoid } from "nanoid/non-secure";
import * as React from "react";
import useLatestCallback from "use-latest-callback";
import useNavigation from "./useNavigation";
import usePreventRemoveContext from "./usePreventRemoveContext";
import useRoute from "./useRoute";
/**
 * Hook to prevent screen from being removed. Can be used to prevent users from leaving the screen.
 *
 * @param preventRemove Boolean indicating whether to prevent screen from being removed.
 * @param callback Function which is executed when screen was prevented from being removed.
 */ export default function usePreventRemove(preventRemove, callback) {
    var _React_useState = _sliced_to_array(React.useState(function() {
        return nanoid();
    }), 1), id = _React_useState[0];
    var navigation = useNavigation();
    var _useRoute = useRoute(), routeKey = _useRoute.key;
    var setPreventRemove = usePreventRemoveContext().setPreventRemove;
    React.useEffect(function() {
        setPreventRemove(id, routeKey, preventRemove);
        return function() {
            setPreventRemove(id, routeKey, false);
        };
    }, [
        setPreventRemove,
        id,
        routeKey,
        preventRemove
    ]);
    var beforeRemoveListener = useLatestCallback(function(e) {
        if (!preventRemove) {
            return;
        }
        e.preventDefault();
        callback({
            data: e.data
        });
    });
    React.useEffect(function() {
        return navigation === null || navigation === void 0 ? void 0 : navigation.addListener("beforeRemove", beforeRemoveListener);
    }, [
        navigation,
        beforeRemoveListener
    ]);
}
